<template>
  <div class="home" v-if="ready">
    <v-card flat width="100%" tile class="d-flex align-center admin" v-if="isSuperAdmin">
      <div class="text-center card-content">
        <v-icon dark size="64">mdi-security</v-icon>
        <v-card color="transparent" dark flat class="my-6">
          <v-card-title class="justify-center display-2">Administration</v-card-title>
          <v-card-subtitle class="subtitle-1">
            <div>Create and manage APIs, front applications and services accounts.</div>
            <div>Create and manage roles & scopes.</div>
            <div>Create and manage organizations, their locations and their conepts.</div>
          </v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn color="transparent" elevation="8" @click="$router.push('/admin/apis')">Go To</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card>
    <v-card flat width="100%" tile class="d-flex align-center orga" v-if="isAdmin || isSuperAdmin">
      <div class="text-center card-content">
        <v-icon dark size="64">apartment</v-icon>
        <v-card color="transparent" dark flat class="my-6">
          <v-card-title class="justify-center display-2">Organization</v-card-title>
          <v-card-subtitle class="subtitle-1">
            <div>Add and remove users from organization.</div>
            <div>Grant users admin, editor or viewer role for one organization.</div>
          </v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn color="transparent" elevation="8" @click="$router.push('/access/users')">Go To</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card>
    <v-card
      flat
      width="100%"
      tile
      class="d-flex align-center groups"
      v-if="isEditor || isAdmin || isSuperAdmin"
    >
      <div class="text-center card-content">
        <v-icon dark size="64">group_add</v-icon>
        <v-card color="transparent" dark flat class="my-6">
          <v-card-title class="justify-center display-2">Groups</v-card-title>
          <v-card-subtitle class="subtitle-1">
            <div>Create and manage organization groups.</div>
            <div>Associate application accesses to groups.</div>
            <div>Add and remove users from organization groups.</div>
          </v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn color="transparent" elevation="8" @click="$router.push('/access/groups')">Go To</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card>
    <v-card
      flat
      width="100%"
      tile
      class="d-flex align-center rights"
      v-if="isEditor || isAdmin || isSuperAdmin"
    >
      <div class="text-center card-content">
        <v-icon color="black" size="64">local_dining</v-icon>
        <v-card color="transparent" flat class="my-6">
          <v-card-title class="justify-center display-2">Rights</v-card-title>
          <v-card-subtitle class="subtitle-1">
            <div>Create and manage organization rights: locations and concepts.</div>
            <div>Add and remove users from organization location or concept as an admin, editor or viewer role.</div>
          </v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn color="transparent" elevation="8" @click="$router.push('/access/rights')">Go To</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card>
    <v-card flat width="100%" tile class="d-flex align-center profile">
      <div class="text-center card-content">
        <v-icon color="black" size="64">face</v-icon>
        <v-card color="transparent" flat class="my-6">
          <v-card-title class="justify-center display-2">Profile</v-card-title>
          <v-card-subtitle class="subtitle-1">
            <div>See your personal information.</div>
            <div>Review your rights in your organizations (organization, locations, concepts and applicative roles).</div>
          </v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn color="transparent" elevation="8" @click="$router.push('/profile')">Go To</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import Roles from "@/router/roles";

export default {
  name: "Home",
  data() {
    return {
      ready: false,
      isSuperAdmin: false,
      isAdmin: false,
      isEditor: false,
      delay: 500
    };
  },
  computed: {},
  methods: {
    setHome() {
      if (this.$auth.getUserRoles().includes(Roles.SuperAdmin)) {
        this.isSuperAdmin = true;
      }
      if (this.$auth.getUserRoles().includes(Roles.Admin)) {
        this.isAdmin = true;
      }
      if (this.$auth.getUserRoles().includes(Roles.Editor)) {
        this.isEditor = true;
      }
    }
  },
  mounted() {
    setInterval(() => {
      if (this.$auth.keycloak.tokenParsed) {
        this.delay = 60000;
        this.setHome();
        this.ready = true;
      }
    }, this.delay);
  }
};
</script>
<style scoped>
.card-content {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
}
.admin {
  background-color: black;
  background: linear-gradient(180deg, black 0%, #1565c0 100%);
}
.orga {
  background-color: #1565c0;
  background: linear-gradient(180deg, #1565c0 0%, #1e88e5 100%);
}
.groups {
  background-color: #1e88e5;
  background: linear-gradient(180deg, #1e88e5 0%, #42a5f5 100%);
}
.rights {
  background-color: #42a5f5;
  background: linear-gradient(180deg, #42a5f5 0%, #90caf9 100%);
}
.profile {
  background-color: #90caf9;
  background: linear-gradient(180deg, #90caf9 0%, #fafafa 100%);
}
</style>
